
<!-- RentWise Table -->
<section>
  <div class="container content-box">
    <h1><b>RentWise Public Records</b></h1>
    <h2>User Email: </h2>
    <p><input type="text" class="form-control" id="username" name="userSearch" (keypress)="onChangeEvent($event)"[(ngModel)]="userSearch"></p>
    <!-- <div class="container-flud content-box">

    </div> -->
    <div>
      <div *ngIf="search === true" class="Icons">
        <h2 *ngIf="isCompleted === false" ><i  class="fas fa-times-circle" style="color: red"></i>  {{requestedUser.progress}} </h2>
        <h2 *ngIf="isCompleted === true" ><i  class="fas fa-check-circle" style="color: green"></i> {{requestedUser.progress}} <span *ngIf="requestedUser.completionDate">on {{ requestedUser.completionDate | date }}</span> </h2>
      </div>
    </div>

    <button type="button" class="btn waves-dark" (click)="searchUser()">Search User</button>
  </div>


</section>
